import { Component, type ErrorInfo, type ReactNode } from 'react';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Application render failed', error, errorInfo);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="flex min-h-screen items-center justify-center bg-background p-6">
        <section className="w-full max-w-lg rounded-lg border border-border bg-card p-6 text-center shadow-sm">
          <img src="/logo.svg" alt="Omni AI" className="mx-auto mb-4 h-12 w-12" />
          <h1 className="font-brand text-xl text-foreground">
            Omni AI could not load this view
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Refresh the page. If the problem continues, contact your organization
            administrator.
          </p>
          <button
            type="button"
            className="mt-5 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </section>
      </main>
    );
  }
}
